export const environment = {
  apiUrl: 'https://localhost:5003/',
  resellerServerUrl: 'http://localhost:5253/',
  appVersion: '9.7.13',
  releaseDate: '1389-1405',
  production: false,
  isLocal: true,
  martinBaseUrl: 'https://map.sms.ir',

  cookieDomain: '.testsms.ir',
  cookieSecure: true,
  cookieSameSite: 'Lax',
};
